import { createContext, useContext } from 'react'

import { ConditionFeatureFlag } from '@makyoapp/makyo-common'
import { ConditionValue } from '@makyoapp/makyo-common/dist/condition'

export const ConditionRepeaterContext = createContext<{
  id?: string
  onChange?: (nextValue: ConditionValue) => void
  value: ConditionValue
  featureFlags: ConditionFeatureFlag
  parentFormId?: string
} | null>(null)

export function useConditionRepeaterContext() {
  const context = useContext(ConditionRepeaterContext)
  if (!context) {
    throw new Error('useConditionRepeaterContext must be used within a ConditionRepeaterContext provider')
  }
  return context
}
